import React from 'react'
import {
  Table,
} from 'semantic-ui-react'
import ItemCounter from './ItemCounter.js'
import ItemBars from './ItemBars.js'
import ItemCircle from './ItemCircle.js'
import OverallItemCounter from './OverallItemCounter.js'
import OverallItemBars from './OverallItemBars.js'
import {isItem} from './itemInfo.js'

const OptionalCompareItemCells = ({mode, comparisonMode, comparisonSelectionNames, selections, fqidPrefix, itemKind}) => {
  if (mode==='compare') {
    if (comparisonMode==='juxtaposeCounts'||comparisonMode==='juxtaposeBarsCount'||comparisonMode==='juxtaposeBarsPercent') {
      return comparisonSelectionNames.map(name=>{
        const selection = selections.find(s=>s.id===name);
        //console.log("selection:", selection);
        return (
          <Table.Cell key={name} collapsing textAlign='left' style={{paddingLeft: '2px', paddingRight: '2px'}}>
            {
              isItem(fqidPrefix)
              ?
                <ItemCircle
                  type={selection.type}
                  item={selection.items[fqidPrefix]}
                />
              :
              (
                comparisonMode==='juxtaposeCounts'
                ?
                <ItemCounter
                  type={selection.type}
                  items={selection.items}
                  fqidPrefix={fqidPrefix}
                  itemKind={itemKind}
                />
                :
                <ItemBars
                  percent={comparisonMode==='juxtaposeBarsPercent'}
                  type={selection.type}
                  items={selection.items}
                  fqidPrefix={fqidPrefix}
                  itemKind={itemKind}
                />
              )
            }
          </Table.Cell>
        );
      });
    } else {
      // overall
      const comparisonSelections = comparisonSelectionNames.map(name=>{
        return selections.find(s=>s.id===name);
      });
      return (
        <Table.Cell collapsing textAlign='left'>
          {
            comparisonMode==='overallCounts'
            ?
            <OverallItemCounter
              comparisonSelections={comparisonSelections}
              fqidPrefix={fqidPrefix}
              itemKind={itemKind}
            />
            :
            <OverallItemBars
              percent={comparisonMode==='overallBarsPercent'}
              comparisonSelections={comparisonSelections}
              fqidPrefix={fqidPrefix}
              itemKind={itemKind}
            />
          }
        </Table.Cell>
      );
    }
  } else {
    return null;
  }
}

export default OptionalCompareItemCells